import React from "react";

/**
 * VoucherBalanceStatus
 * @param {object} props
 * @param {number} props.balance - The balance value
 * @param {number} [props.size=14] - The diameter of the ball in px
 * @param {object} [props.style] - Additional style
 */
export function VoucherBalanceStatus({ balance, size = 14, style }) {
  const isPositive = (balance ?? 0) > 0;
  const color = isPositive ? "#52c41a" : "#ff4d4f";
  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "50%",
        background: color,
        ...style,
      }}
    />
  );
}
